define('../src/sublayouts/m31-count/m31-count',['jquery'], function ($) {
    'use strict';

    var M31_COUNT = function ($component) {

        this.$component = $component;
        return this;
    };

    M31_COUNT.prototype.init = function () {
        var _this = this;
        var countdownElement = _this.$component.find(".countdown");
        var targetDate = new Date(countdownElement.data("target-date")).getTime();

        function updateCountdown() {
            var now = new Date().getTime();
            var timeRemaining = targetDate - now;

            if (timeRemaining > 0) {
                var days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
                var hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                var minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
                var seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

                if (days >= 100) {
                    $("#days-digit-1").text(Math.floor(days / 100));
                    $("#days-digit-2").text(Math.floor((days % 100) / 10));
                    $("#days-digit-3").text(days % 10);
                } else if (days >= 10) {
                    $("#days-digit-1").hide();
                    $("#days-digit-2").text(Math.floor(days / 10));
                    $("#days-digit-3").text(days % 10);
                } else {
                    $("#days-digit-1").text("0");
                    $("#days-digit-2").text(days);
                    $("#days-digit-3").hide();
                }

                $("#hours-digit-1").text(Math.floor(hours / 10));
                $("#hours-digit-2").text(hours % 10);
                $("#minutes-digit-1").text(Math.floor(minutes / 10));
                $("#minutes-digit-2").text(minutes % 10);
                $("#seconds-digit-1").text(Math.floor(seconds / 10));
                $("#seconds-digit-2").text(seconds % 10);
            } else {
                clearInterval(countdownInterval);
                countdownElement.html("<p>Countdown expired!</p>");
            }
        }


            updateCountdown();
            var countdownInterval = setInterval(updateCountdown, 1000);
    };

    return M31_COUNT;
});

